import { ProfileInfoCard } from "@/components/settings/ProfileInfoCard";
import { ChangePasswordCard } from "@/components/settings/ChangePasswordCard";

export default function AdminProfile() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-4xl font-heading font-extrabold">Profile</h1>
      <ProfileInfoCard />
      <ChangePasswordCard />
    </div>
  );
}
